<div
  [ngClass]="{
    'main-router-outlet': isDashboard && !isExpand,
    'dark-theme': analytics.currentTheme === 'material-dark'
  }"
>
  <ngx-spinner
    template="<img src='/assets/icons/Respond-spinner.gif' height='170' width='170' class='text-center'  loading='lazy'/>"
    [showSpinner]="loading"
    *ngIf="(route.url.includes('admin-dashboard') && isExpand) || route.url.includes('teacher-dashboard')"
    size="small"
    [disableAnimation]="false"
    color="white"
    bdColor="rgba(0,0,0,0.5)"
    [fullScreen]="true"
    [zIndex]="1003"
  >
  </ngx-spinner>

  <div *ngIf="isDashboard && isExpand" class="text-right mb-2"></div>
  <div class="row">
    <div class="col-md-12 teachers">
      <div
        class="d-flex align-items-center"
        [ngClass]="{
          'd-flex': true,
          'mt-2': isDashboard && !isExpand,
          'mt-3': !isDashboard
        }"
      >
        <div>
          <h5 class="quicksand-bold-label mt-2 mb-0" *ngIf="!isDashboard">Teacher Dashboard</h5>
          <span class="quicksand-normal-label span-label" *ngIf="!isDashboard">School teachers list </span>
        </div>

        <label class="quicksand-bold-label dark-mode-label-color { !isExpand ? 'dashboard-view-label' : 'pt-2' }" *ngIf="isDashboard"
          >Click on a Teacher to view their dashboard as "View-Only" to oversee academic progress in their classes</label
        >
      </div>
      <hr *ngIf="!isDashboard && storageService.detectMob()" class="hr-color" />

      <div
        [ngClass]="{
          'd-flex': !storageService.detectMob(),
          'd-block mobile-content': storageService.detectMob()
        }"
      >
        <div class="form-group has-search mr-0 mt-2" [ngClass]="isDashboard && !isExpand ? 'has-search-sm' : ''">
          <img
            src="/assets/icons/search.svg"
            alt="search-icon"
            class="mt-1 form-control-feedback"
            height="17"
            width="17"
            *ngIf="!isDashboard || isExpand"
          />

          <img
            *ngIf="isDashboard && !isExpand"
            src="/assets/icons/search.svg"
            alt="search-icon"
            class="mt-1 search-icon-sm"
            height="17"
            width="17"
          />
          <input
            type="text"
            class="form-control {{ isExpand ? 'form-control-mt-content' : '' }}"
            placeholder="Search Teacher"
            [(ngModel)]="searchText"
            [ngClass]="isDashboard && !isExpand ? 'sm-input-content' : ''"
            [formControl]="searchControl"
          />
        </div>
      </div>
    </div>
  </div>

  <hr *ngIf="!isDashboard && !storageService.detectMob()" class="hr-color" />

  <div
    *ngIf="!isDashboard"
    [ngClass]="{
      'text-center': !storageService.detectMob(),
      'text-start': storageService.detectMob()
    }"
  >
    <label class="quicksand-bold-label dark-mode-label-color" *ngIf="!storageService.detectMob()"
      >Click to Teacher below to view the dashboard.</label
    >
    <label class="quicksand-bold-label dark-mode-label-color tap-card" *ngIf="storageService.detectMob()"
      >Tap on card to view dashboard.</label
    >
  </div>

  <!-- <div class="row">
    <div class="col-md-12">
      <table
        class="table table-hover table-small mt-2 teacher-list-table table-border-radius"
        *ngIf="!storageService.detectMob()"
      >
        <thead *ngIf="teachers && teachers?.length > 0">
          <tr
            class="table-header-row table-header-dark"
            [ngClass]="isDashboard && !isExpand ? 'sm-content' : ''"
          >
            <th scope="col" class="main-header">Profile</th>
            <th scope="col" class="main-header">Name</th>
            <th scope="col" class="main-header" *ngIf="!isDashboard">Role</th>
            <th scope="col" class="main-header">Contact</th>
            <th scope="col" class="main-header">Email</th>
            <th
              scope="col"
              class="main-header"
              *ngIf="user?.user?.role_id === 19"
            >
              School
            </th>

            <th scope="col" class="main-header">
              <span *ngIf="isDashboard"
                ><span *ngIf="isExpand">Academic Pacing</span> Status</span
              >
            </th>
            <th scope="col" class="main-header" *ngIf="isDashboard && isExpand">
              Last Active
            </th>
            <th scope="col" class="main-header" *ngIf="isDashboard && isExpand">
              Pacing Plans/Classes
            </th>
            <th scope="col" class="main-header" *ngIf="isDashboard && isExpand">
              Lesson Plans/Standards<br />(To date)
            </th>
            <th scope="col" class="main-header" *ngIf="isDashboard && isExpand">
              ESSA Compliance
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            *ngFor="let teacher of teachers | userSearch : searchText"
            class="cursor-pointer user-list"
            [ngClass]="isDashboard && !isExpand ? 'sm-content' : ''"
            (click)="showTeacherDashboard(teacher.id)"
          >
            <td>
              <img
                src="/assets/images/no-profile-image.png"
                alt="profile-img"
                height="35"
                width="35"
                class="profile-img"
                *ngIf="teacher?.user_profile_media_id === 0"
              />
              <img
                [src]="teacher?.user_profile_media?.image?.url"
                alt="profile-img"
                height="35"
                width="35"
                class="profile-img"
                *ngIf="teacher?.user_profile_media_id > 0"
              />
            </td>
            <td class="user-data">
              {{ teacher?.firstName | titlecase }}
              {{ teacher?.lastName | titlecase }}
            </td>
            <td class="user-data" *ngIf="!isDashboard">
              {{ teacher?.role?.name }}
            </td>
            <td class="user-data">
              {{
                teacher?.contact
                  ? (teacher?.contact | mask : '(000) 000-0000')
                  : '-'
              }}
            </td>
            <td class="user-data">{{ teacher?.email }}</td>
            <td class="user-data" *ngIf="user?.user?.role_id === 19">
              {{ teacher?.school?.name ? teacher?.school?.name : '-' }}
            </td>

            <td class="user-data" [ngClass]="isDashboard ? '' : 'text-center'">
              <img
                src="/assets/icons/forward.svg"
                alt="forward-img"
                height="15"
                width="15"
                class="img-dark img-icon-dark"
                *ngIf="!isDashboard"
              />
              <div *ngIf="isDashboard" class="text-danger">On Track</div>
            </td>
            <td class="user-data" *ngIf="isDashboard && isExpand">
              <div *ngIf="isDashboard && isExpand" class="text-success">
                {{teacher?.time_management_of_user?.[0] ? (teacher?.time_management_of_user[0].sessions[0].startTime | date: 'short') : '-'}}
              </div>
            </td>
            <td class="user-data" *ngIf="isDashboard && isExpand">
              <div *ngIf="isDashboard && isExpand" class="text-success">
                {{
                  (teacher?.total_manual_pacing_plan
                    ? teacher?.total_manual_pacing_plan
                    : 0) +
                    (teacher?.total_auto_populate_pacing_plan_count
                      ? teacher?.total_auto_populate_pacing_plan_count
                      : 0)
                }}/
                {{
                  teacher?.classroom_list ? teacher?.classroom_list?.length : 0
                }}
              </div>
            </td>

            <td class="user-data" *ngIf="isDashboard && isExpand">
              <div *ngIf="isDashboard && isExpand" class="text-success">
                {{
                  (teacher?.total_added_manual_pacing_plans_till_date
                    ? teacher?.total_added_manual_pacing_plans_till_date
                    : 0) +
                    (teacher?.auto_populate_global_pacing_plan_list_till_date
                      ? teacher?.auto_populate_global_pacing_plan_list_till_date
                      : 0)
                }}/{{
                  teacher?.total_lesson_plan ? teacher?.total_lesson_plan : 0
                }}
              </div>
            </td>
            <td class="user-data" *ngIf="isDashboard && isExpand">
              <div
                *ngIf="
                  teacher?.profileData?.credentialExpirationDate >
                    teacher?.profileData?.tbClearanceDate <
                    currentDate &&
                    currentDate &&
                    teacher?.profileData?.tbExpirationDate > currentDate;
                  else notInCompliance
                "
                class="text-success"
              >
                In Compilance
              </div>
              <ng-template #notInCompliance>
                <div class="text-danger">Need Attension</div>
              </ng-template>
              <div></div>
            </td>
          </tr>
        </tbody>
      </table>

      <div *ngIf="storageService.detectMob()">
        <nb-card
          *ngFor="let teacher of teachers | userSearch : searchText"
          class="cursor-pointer user-card"
          (click)="showTeacherDashboard(teacher.id)"
        >
          <nb-card-body class="row">
            <div class="col-12 mb-1">
              <img
                src="/assets/images/no-profile-image.png"
                alt="profile-img"
                height="43"
                width="43"
                class="profile-img"
                *ngIf="teacher?.user_profile_media_id === 0"
              />
              <img
                [src]="teacher?.user_profile_media?.image?.url"
                alt="profile-img"
                height="43"
                width="43"
                class="profile-img"
                *ngIf="teacher?.user_profile_media_id > 0"
              />

              <label class="name-content"
                >{{ teacher?.firstName | titlecase }}
                {{ teacher?.lastName | titlecase }}</label
              >
            </div>
            <div class="col-md-3 col-sm-4 col-3">
              <label class="title">Role:</label>
            </div>
            <div class="col-md-9 col-sm-8 col-9">
              <label class="title-contents">{{ teacher?.role?.name }}</label>
            </div>
            <div class="col-md-3 col-sm-4 col-3">
              <label class="title">Contact:</label>
            </div>
            <div class="col-md-9 col-sm-8 col-9">
              <label class="title-contents">
                {{
                  teacher?.contact
                    ? (teacher?.contact | mask : '(000) 000-0000')
                    : '-'
                }}
              </label>
            </div>
            <div class="col-md-3 col-sm-4 col-3">
              <label class="title">Email:</label>
            </div>
            <div class="col-md-9 col-sm-8 col-9">
              <label class="title-contents">{{ teacher?.email }}</label>
            </div>

            <div class="col-md-3 col-sm-4 col-3">
              <label class="title">School: </label>
            </div>
            <div class="col-md-9 col-sm-8 col-9">
              <label class="title-contents">
                {{ teacher?.school ? teacher?.school?.name : '-' }}
              </label>
            </div>
          </nb-card-body>
        </nb-card>
      </div>
    </div>
  </div> -->

  <div class="row">
    <div class="col-md-12">
      <table
        class="table table-hover table-small mt-2 teacher-list-table table-border-radius"
        *ngIf="!storageService.detectMob() && (teachers | userSearch : searchText).length > 0"
      >
        <thead *ngIf="teachers && teachers?.length > 0">
          <tr class="table-header-row table-header-dark" [ngClass]="isDashboard && !isExpand ? 'sm-content' : ''">
            <th scope="col" class="main-header text-center align-middle">Profile</th>
            <th scope="col" class="main-header text-center align-middle">
              <div class="header-content">
                Name
                <nb-icon
                  class="sort-icon"
                  icon="arrow-upward"
                  (click)="sortBy('lastName', true)"
                  *ngIf="isSortedByLastName === null || (isSortedByLastName && sortAscendingLastName)"
                ></nb-icon>

                <!-- Sort Down Icon for 'lastName' -->
                <nb-icon
                  class="sort-icon"
                  icon="arrow-downward"
                  (click)="sortBy('lastName', false)"
                  *ngIf="isSortedByLastName === null || (isSortedByLastName && !sortAscendingLastName)"
                ></nb-icon>
              </div>
            </th>
            <th scope="col" class="main-header text-center align-middle">Subject</th>
            <th scope="col" class="main-header text-center align-middle">
              Last Active
              <nb-icon
                class="sort-icon"
                icon="arrow-upward"
                (click)="sortBy('lastactive', true)"
                *ngIf="isSortedByLastActive === null || (isSortedByLastActive && sortAscendingLastActive)"
              ></nb-icon>

              <!-- Sort Down Icon for 'lastactive' -->
              <nb-icon
                class="sort-icon"
                icon="arrow-downward"
                (click)="sortBy('lastactive', false)"
                *ngIf="isSortedByLastActive === null || (isSortedByLastActive && !sortAscendingLastActive)"
              ></nb-icon>
            </th>
            <th scope="col" class="main-header text-center align-middle">
              Pacing Plans/<br />
              Classes
            </th>
            <th scope="col" class="main-header text-center align-middle">
              Lesson Plans/<br />
              Standards (To Date)
            </th>

            <th scope="col" class="main-header text-center align-middle">
              ESSA<br />
              Compliance
            </th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr
            *ngFor="let teacher of teachers | userSearch : searchText"
            class="cursor-pointer user-list"
            [ngClass]="isDashboard && !isExpand ? 'sm-content' : ''"
            (click)="showTeacherDashboard(teacher.id)"
          >
            <td class="text-center align-middle">
              <div class="profile-container">
                <!-- <span
                  class="dot-content"
                  [ngClass]="getStatusClass(teacher.user_activity_status)"
                ></span> -->

                <img
                  [src]="getStatusImagePath(teacher.user_activity_status)"
                  alt="dot-content"
                  class="dot-content"
                  *ngIf="teacher.user_activity_status"
                />
                <img
                  src="/assets/images/no-profile-image.png"
                  alt="profile-img"
                  height="35"
                  width="35"
                  class="profile-img"
                  *ngIf="utilService.getProfileImage(teacher)"
                />
                <img
                  [src]="teacher?.user_profile_media?.image?.url"
                  alt="profile-img"
                  height="35"
                  width="35"
                  class="profile-img"
                   *ngIf="!utilService.getProfileImage(teacher)"
                />
                
              </div>
            </td>
            <td class="user-data text-center align-middle">
              {{ teacher?.firstName | titlecase }}
              {{ teacher?.lastName | titlecase }}
            </td>
            <!-- <td class="user-data text-center align-middle" *ngIf="!isDashboard">
              {{ teacher?.role?.name }}
            </td> -->
            <td class="user-data text-center child-loading-element align-middle">
              <label class="overflow-ellipsis text-center" matTooltip="{{ teacher?.teachingSubjectName ?? '' }}" matTooltipPosition="above">
                {{ teacher?.teachingSubjectName ?? '-' }}</label
              >
            </td>
            <td
              [ngClass]="{
                'text-success': isUserActive(
                  teacher?.last_user_activity_log_of_user?.expired_time
                    ? teacher?.last_user_activity_log_of_user?.expired_time
                    : teacher?.last_user_activity_log_of_user?.created_at
                ),
                'text-danger': !isUserActive(
                  teacher?.last_user_activity_log_of_user?.expired_time
                    ? teacher?.last_user_activity_log_of_user?.expired_time
                    : teacher?.last_user_activity_log_of_user?.created_at
                )
              }"
              class="user-data text-center align-middle"
            >
              {{
                teacher?.last_user_activity_log_of_user
                  ? ((teacher?.last_user_activity_log_of_user.expired_time
                      ? teacher?.last_user_activity_log_of_user.expired_time
                      : teacher?.last_user_activity_log_of_user.created_at
                    ) | date : 'MM-dd-yyyy')
                  : '-'
              }}
              <br />
              {{
                teacher?.last_user_activity_log_of_user
                  ? ((teacher?.last_user_activity_log_of_user.expired_time
                      ? teacher?.last_user_activity_log_of_user.expired_time
                      : teacher?.last_user_activity_log_of_user.created_at
                    ) | date : 'hh:mm a')
                  : ''
              }}
            </td>

            <td
              class="user-data text-center child-loading-element align-middle"
              [nbSpinner]="childLoading"
              size="tiny"
              nbSpinnerSize="small"
              nbSpinnerStatus="primary"
            >
              <div
                *ngIf="!childLoading"
                [ngClass]="{
                  'text-success':
                    (teacher?.countClassWithPlans || 0) === (teacher?.classroom_list?.length || 0) &&
                    (teacher?.countClassWithPlans || 0) !== 0,
                  'text-danger':
                    (teacher?.countClassWithPlans || 0) !== (teacher?.classroom_list?.length || 0) ||
                    ((teacher?.countClassWithPlans || 0) === 0 && (teacher?.classroom_list?.length || 0) === 0)
                }"
              >
                {{ teacher?.countClassWithPlans ? teacher?.countClassWithPlans : 0 }}/{{
                  teacher?.classroom_list ? teacher?.classroom_list?.length : 0
                }}
              </div>
            </td>
            <td
              class="user-data text-center child-loading-element align-middle"
              [nbSpinner]="childLoading"
              size="tiny"
              nbSpinnerSize="small"
              nbSpinnerStatus="primary"
            >
              <div
                *ngIf="!childLoading"
                [ngClass]="{
                  'text-success':
                    (teacher?.total_lesson_plan || 0) === (teacher?.auto_populate_global_pacing_plan_list_till_date || 0) &&
                    (teacher?.total_lesson_plan || 0) !== 0,
                  'text-danger':
                    (teacher?.total_lesson_plan || 0) !== (teacher?.auto_populate_global_pacing_plan_list_till_date || 0) ||
                    ((teacher?.total_lesson_plan || 0) === 0 && (teacher?.auto_populate_global_pacing_plan_list_till_date || 0) === 0)
                }"
              >
                <!-- show the lesson plan count in green color only if lesson plan count is strictly greater than pacing plan count otherwise show in red color text -->
                <span
                  [ngClass]="{
                    'text-success':
                      (teacher?.total_lesson_plan || 0) >
                      (teacher?.total_added_manual_pacing_plans_till_date || 0) +
                        (teacher?.auto_populate_global_pacing_plan_list_till_date || 0),
                    'text-danger':
                      (teacher?.total_lesson_plan || 0) <=
                      (teacher?.total_added_manual_pacing_plans_till_date || 0) +
                        (teacher?.auto_populate_global_pacing_plan_list_till_date || 0)
                  }"
                  >{{ teacher?.total_lesson_plan || 0 }}</span
                >/{{
                  (teacher?.total_added_manual_pacing_plans_till_date || 0) +
                    (teacher?.auto_populate_global_pacing_plan_list_till_date || 0)
                }}
              </div>
            </td>
            <td class="user-data text-center align-middle">
              <!-- teacher?.profileData?.credentialExpirationDate >
                teacher?.profileData?.tbClearanceDate <
                currentDate &&
                currentDate &&
                teacher?.profileData?.tbExpirationDate > currentDate; -->
              <div
                *ngIf="
                  teacher.essa_grid &&
                    teacher.essa_grid.subject_authorization !== null &&
                    teacher.essa_grid.subject_authorization.length > 0 &&
                    teacher.essa_status;
                  else notInCompliance
                "
                class="text-success"
              >
                In Compliance
              </div>
              <ng-template #notInCompliance>
                <div class="text-danger">Need Attention</div>
              </ng-template>
            </td>

            <td class="user-data text-center align-middle" (click)="showTeacherDashboard(teacher.id)">
              <nb-icon icon="arrow-forward-outline" class="arrow-forward-outline"></nb-icon>
            </td>
          </tr>
        </tbody>
      </table>
      <!-- 
      <div *ngIf="storageService.detectMob()">
        <nb-card
          *ngFor="let teacher of teachers | userSearch : searchText"
          class="cursor-pointer user-card"
          (click)="showTeacherDashboard(teacher.id)"
        >
          <nb-card-body class="row">
            <div class="col-12 mb-1">
              <img
                src="/assets/images/no-profile-image.png"
                alt="profile-img"
                height="43"
                width="43"
                class="profile-img"
                *ngIf="teacher?.user_profile_media_id === 0"
              />
              <img
                [src]="teacher?.user_profile_media?.image?.url"
                alt="profile-img"
                height="43"
                width="43"
                class="profile-img"
                *ngIf="teacher?.user_profile_media_id > 0"
              />

              <label class="name-content"
                >{{ teacher?.firstName | titlecase }}
                {{ teacher?.lastName | titlecase }}</label
              >
            </div>
            <div class="col-md-3 col-sm-4 col-3">
              <label class="title">Role:</label>
            </div>
            <div class="col-md-9 col-sm-8 col-9">
              <label class="title-contents">{{ teacher?.role?.name }}</label>
            </div>
            <div class="col-md-3 col-sm-4 col-3">
              <label class="title">Contact:</label>
            </div>
            <div class="col-md-9 col-sm-8 col-9">
              <label class="title-contents">
                {{
                  teacher?.contact
                    ? (teacher?.contact | mask : '(000) 000-0000')
                    : '-'
                }}
              </label>
            </div>
            <div class="col-md-3 col-sm-4 col-3">
              <label class="title">Email:</label>
            </div>
            <div class="col-md-9 col-sm-8 col-9">
              <label class="title-contents">{{ teacher?.email }}</label>
            </div>

            <div class="col-md-3 col-sm-4 col-3">
              <label class="title">School: </label>
            </div>
            <div class="col-md-9 col-sm-8 col-9">
              <label class="title-contents">
                {{ teacher?.school ? teacher?.school?.name : '-' }}
              </label>
            </div>
          </nb-card-body>
        </nb-card>
      </div> -->

      <div *ngIf="storageService.detectMob() && (teachers | userSearch : searchText).length > 0">
        <nb-card
          *ngFor="let teacher of teachers | userSearch : searchText"
          class="cursor-pointer user-card"
          (click)="showTeacherDashboard(teacher.id)"
        >
          <nb-card-body class="row">
            <div class="col-12 mb-1">
              <div class="profile-container">
                <img
                  [src]="getStatusImagePath(teacher.user_activity_status)"
                  alt="dot-content"
                  class="dot-content"
                  *ngIf="teacher.user_activity_status"
                />

                <img
                  src="/assets/images/no-profile-image.png"
                  alt="profile-img"
                  height="43"
                  width="43"
                  class="profile-img"
                   *ngIf="utilService.getProfileImage(teacher)"
                />
                <img
                  [src]="teacher?.user_profile_media?.image?.url"
                  alt="profile-img"
                  height="43"
                  width="43"
                  class="profile-img"
                   *ngIf="!utilService.getProfileImage(teacher)"
                />

                <label class="name-content">{{ teacher?.firstName | titlecase }} {{ teacher?.lastName | titlecase }}</label>
              </div>
            </div>
            <div class="col-md-3 col-sm-4 col-3 mt-2">
              <label class="title">Subject:</label>
            </div>
            <div class="col-md-9 col-sm-8 col-9 mt-2">
              <label class="title-contents"> {{ teacher?.teachingSubjectName ?? '-' }}</label>
            </div>
            <div class="col-md-3 col-sm-4 col-3">
              <label class="title">Last Active:</label>
            </div>
            <div class="col-md-9 col-sm-8 col-9">
              <label
                class="title-contents"
                [ngClass]="{
                  'text-success': isUserActive(
                    teacher?.last_user_activity_log_of_user?.expired_time
                      ? teacher?.last_user_activity_log_of_user?.expired_time
                      : teacher?.last_user_activity_log_of_user?.created_at
                  ),
                  'text-danger': !isUserActive(
                    teacher?.last_user_activity_log_of_user?.expired_time
                      ? teacher?.last_user_activity_log_of_user?.expired_time
                      : teacher?.last_user_activity_log_of_user?.created_at
                  )
                }"
              >
                {{
                  teacher?.last_user_activity_log_of_user
                    ? ((teacher?.last_user_activity_log_of_user.expired_time
                        ? teacher?.last_user_activity_log_of_user.expired_time
                        : teacher?.last_user_activity_log_of_user.created_at
                      ) | date : 'MM-dd-yyyy')
                    : '-'
                }}
                <br />
                {{
                  teacher?.last_user_activity_log_of_user
                    ? ((teacher?.last_user_activity_log_of_user.expired_time
                        ? teacher?.last_user_activity_log_of_user.expired_time
                        : teacher?.last_user_activity_log_of_user.created_at
                      ) | date : 'hh:mm a')
                    : ''
                }}
              </label>
            </div>
            <div class="col-md-3 col-sm-4 col-3">
              <label class="title">Pacing Plans/ Classes:</label>
            </div>
            <div class="col-md-9 col-sm-8 col-9">
              <label
                class="title-contents"
                [ngClass]="{
                  'text-success':
                    (teacher?.countClassWithPlans || 0) === (teacher?.classroom_list?.length || 0) &&
                    (teacher?.countClassWithPlans || 0) !== 0,
                  'text-danger':
                    (teacher?.countClassWithPlans || 0) !== (teacher?.classroom_list?.length || 0) ||
                    ((teacher?.countClassWithPlans || 0) === 0 && (teacher?.classroom_list?.length || 0) === 0)
                }"
                >{{ teacher?.countClassWithPlans ? teacher?.countClassWithPlans : 0 }}/{{
                  teacher?.classroom_list ? teacher?.classroom_list?.length : 0
                }}</label
              >
            </div>

            <div class="col-md-3 col-sm-4 col-3">
              <label class="title">Lesson Plans/ Standards (To Date): </label>
            </div>
            <div class="col-md-9 col-sm-8 col-9">
              <label
                class="title-contents"
                [ngClass]="{
                  'text-success':
                    (teacher?.total_lesson_plan || 0) === (teacher?.auto_populate_global_pacing_plan_list_till_date || 0) &&
                    (teacher?.total_lesson_plan || 0) !== 0,
                  'text-danger':
                    (teacher?.total_lesson_plan || 0) !== (teacher?.auto_populate_global_pacing_plan_list_till_date || 0) ||
                    ((teacher?.total_lesson_plan || 0) === 0 && (teacher?.auto_populate_global_pacing_plan_list_till_date || 0) === 0)
                }"
              >
                {{ teacher?.total_lesson_plan ? teacher?.total_lesson_plan : 0 }}/{{
                  (teacher?.total_added_manual_pacing_plans_till_date ? teacher?.total_added_manual_pacing_plans_till_date : 0) +
                    (teacher?.auto_populate_global_pacing_plan_list_till_date
                      ? teacher?.auto_populate_global_pacing_plan_list_till_date
                      : 0)
                }}
              </label>
            </div>

            <div class="col-md-3 col-sm-4 col-3">
              <label class="title">ESSA Compliance: </label>
            </div>
            <div class="col-md-9 col-sm-8 col-9">
              <label class="title-contents">
                <div
                  *ngIf="
                    teacher.essa_grid &&
                      teacher.essa_grid.subject_authorization !== null &&
                      teacher.essa_grid.subject_authorization.length > 0 &&
                      teacher.essa_status;
                    else notInCompliance
                  "
                  class="text-success"
                >
                  In Compliance
                </div>
                <ng-template #notInCompliance>
                  <div class="text-danger">Need Attention</div>
                </ng-template>
              </label>
            </div>
          </nb-card-body>
        </nb-card>
      </div>
    </div>
  </div>
  <h6 class="quicksand-bold-label text-center" *ngIf="(teachers | userSearch : searchText).length === 0">
    <img src="/assets/images/respond-edu.svg" alt="no-events-found" height="100" width="100" />
    <br />
    No Teachers Found!
  </h6>

  <ng-container *ngIf="isPaginate && (teachers | userSearch : searchText).length > 0">
    <hr style="margin-top: 0" class="hr-color" *ngIf="currentPage !== 1 || teachers?.length > 0" />
    <div class="pagination d-flex justify-content-between" style="margin-bottom: 35px" *ngIf="currentPage !== 1 || teachers?.length > 0">
      <div class="pt-2">
        <span class="pagination-numbers-count quicksand-bold-label"> Page {{ currentPage }} of {{ totalPages }} </span>
      </div>
      <div>
        <button
          class="btn-paginate mr-2 quicksand-bold-label"
          [disabled]="currentPage === 1"
          (click)="currentPage = currentPage - 1; getListByPage()"
        >
          <label *ngIf="!storageService.detectMob()" class="mb-0"> Previous</label>
          <nb-icon icon="arrow-back-outline" *ngIf="storageService.detectMob()"> </nb-icon>
        </button>
        <nb-select
          placeholder="Select Page"
          class="mr-2 select-button"
          [(selected)]="currentPage"
          (selectedChange)="currentPage = $event; getListByPage()"
          *ngIf="!storageService.detectMob()"
        >
          <nb-option [value]="page" *ngFor="let page of pages">{{ page }} </nb-option>
        </nb-select>

        <button
          class="btn-paginate quicksand-bold-label"
          (click)="currentPage = currentPage + 1; getListByPage()"
          [disabled]="currentPage === totalPages"
          [ngClass]="storageService.detectMob() ? 'mr-2' : ' '"
        >
          <label *ngIf="!storageService.detectMob()" class="mb-0"> Next</label>
          <nb-icon icon="arrow-forward-outline" *ngIf="storageService.detectMob()"> </nb-icon>
        </button>
      </div>
    </div>
  </ng-container>
</div>
